const initialState = {
  salesOrders: [],
  selectedOrder: null,
  assignedOrders: [],
  fulfillmentOrder: null,
  loading: false,
  actionLoading: false,
  error: null
};

const SalesReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Sales Orders
    case 'FETCH_SALES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_SALES_SUCCESS':
      return { ...state, loading: false, salesOrders: action.payload, error: null };
    case 'FETCH_SALES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Get Sales Order by ID
    case 'GET_SALES_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_SALES_SUCCESS':
      return { ...state, actionLoading: false, selectedOrder: action.payload, error: null };
    case 'GET_SALES_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Create Sales Order
    case 'CREATE_SALES_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CREATE_SALES_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        // salesOrders: [action.payload, ...(state.salesOrders || [])],
        error: null
      };
    case 'CREATE_SALES_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Update Sales Order
    case 'UPDATE_SALES_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'UPDATE_SALES_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        error: null
      };
    case 'UPDATE_SALES_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Update Status
    case 'UPDATE_SALES_STATUS_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'UPDATE_SALES_STATUS_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        // salesOrders: state.salesOrders.map(o =>
        //   o.id === action.payload.id ? { ...o, status: action.payload.status } : o
        // ),
        error: null
      };
    case 'UPDATE_SALES_STATUS_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Assign Sales Order to Staff
    case 'ASSIGN_SALES_ORDER_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'ASSIGN_SALES_ORDER_SUCCESS':
      return { ...state, actionLoading: false, error: null };
    case 'ASSIGN_SALES_ORDER_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Fetch Assigned Orders
    case 'FETCH_ASSIGNED_SALES_ORDERS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_ASSIGNED_SALES_ORDERS_SUCCESS':
      return { ...state, loading: false, assignedOrders: action.payload, error: null };
    case 'FETCH_ASSIGNED_SALES_ORDERS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Get Fulfillment/Task Detail (restricted fields, no price/tax/discount)
    case 'GET_SALES_ORDER_FULFILLMENT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_SALES_ORDER_FULFILLMENT_SUCCESS':
      return { ...state, actionLoading: false, fulfillmentOrder: action.payload, error: null };
    case 'GET_SALES_ORDER_FULFILLMENT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Submit Fulfillment (confirmed quantities -> order becomes 'confirmed')
    case 'SUBMIT_SALES_ORDER_FULFILLMENT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'SUBMIT_SALES_ORDER_FULFILLMENT_SUCCESS':
      return { ...state, actionLoading: false, error: null };
    case 'SUBMIT_SALES_ORDER_FULFILLMENT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Delete Sales Order
    case 'DELETE_SALES_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'DELETE_SALES_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        // salesOrders: state.salesOrders.filter((o) => o.id !== action.payload),
        error: null
      };
    case 'DELETE_SALES_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default SalesReducer;